import React from 'react';

/* Shared pieces of a Factory OS Thread illustration. A Thread is the product's
   home — never a chat window — so every illustration opens on its brief:
   Purpose, Where it stands, Your next step. */

export const sans = "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
export const mono = "ui-monospace, 'SF Mono', 'Cascadia Code', Menlo, Consolas, monospace";

export const threadShell = {
  background: 'var(--wb-paper)',
  border: '1px solid var(--wb-line)',
  borderRadius: 16,
  overflow: 'hidden',
  boxShadow: '0 12px 28px var(--wb-shadow)',
};

export const ThreadHeader = ({ label, title, context }) => (
  <div
    className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1"
    style={{ padding: '11px 18px', borderBottom: '1px solid var(--wb-line)', background: 'var(--wb-soft)' }}
  >
    <span style={{ fontFamily: mono, fontSize: 'var(--t-sm)', fontWeight: 800, letterSpacing: '0.1em', color: 'var(--wb-orange)', textTransform: 'uppercase' }}>
      {label} · <span style={{ color: 'var(--wb-ink)' }}>{title}</span>
    </span>
    {context && <span style={{ fontFamily: mono, fontSize: 'var(--t-sm)', color: 'var(--wb-muted)' }}>{context}</span>}
  </div>
);

export const ThreadBrief = ({ rows }) => (
  <dl style={{ margin: 0, padding: '14px 18px', display: 'grid', gap: 10, borderBottom: '1px solid var(--wb-line)' }}>
    {rows.map(([k, v]) => (
      <div key={k} className="flex flex-col sm:flex-row sm:gap-4">
        <dt className="sm:w-[132px] sm:flex-none" style={{ fontFamily: mono, fontSize: 'var(--t-sm)', color: 'var(--wb-muted)', letterSpacing: '0.06em', textTransform: 'uppercase', paddingTop: 2 }}>{k}</dt>
        <dd style={{ margin: 0, fontFamily: sans, fontSize: 'var(--t-md)', color: 'var(--wb-ink)', lineHeight: 1.5, fontWeight: k === 'Your next step' ? 700 : 400 }}>{v}</dd>
      </div>
    ))}
  </dl>
);
